import { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../../utils/api';

const API = process.env.REACT_APP_API_URL;

export default function AdminBlog() {
  const [posts, setPosts] = useState([]);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    api.get(`${API}/api/admin/posts`).then(res => setPosts(res.data)).catch(() => {});
  }, []);

  const handlePublish = async () => {
    await api.post(`${API}/api/admin/posts`, { title, content, published: true });
    setTitle('');
    setContent('');
    api.get(`${API}/api/admin/posts`).then(res => setPosts(res.data));
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Blog / Lookbook</h2>
      <div className="mb-4 space-y-2">
        <input type="text" placeholder="Post title" className="border p-2 w-full" value={title} onChange={e => setTitle(e.target.value)} />
        <textarea placeholder="Content..." className="border p-2 w-full h-24" value={content} onChange={e => setContent(e.target.value)} />
        <button onClick={handlePublish} className="bg-black text-white px-4 py-2">Publish</button>
      </div>
      <ul className="space-y-2">
        {posts.map(post => (
          <li key={post.id} className="border p-2 flex justify-between">
            <span>{post.title}</span>
            <span className="text-sm text-gray-500">{post.published ? 'Published' : 'Draft'}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}